import "./SignIn.css";
import Header from "./landingComponents/Header";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const SignIn = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    role: "subscriber",
  });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setFormData((prevData) => ({
      ...prevData,
      role: isChecked ? "subscriber" : "admin",
    }));
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleClickEvent = async (e) => {
    e.preventDefault();

    if (formData.email == "" || formData.password == "") {
      Swal.fire({
        icon: "error",
        title: "Fill in all required fields",
        text: "Fail to log in to your account.",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        style: {
          backgroundColor: "var(--color-black)",
        },
      });
      return;
    }
    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/user/login-user",

        formData
      );
      // Handle response based on server's response
      if (response.status === 200) {
        // Handle successful creation of user
        const userData = JSON.parse(response.data.user)[0].fields;
        const role = userData.role;
        secureLocalStorage.setItem("role", role);
        secureLocalStorage.setItem("userInfo", JSON.stringify(userData));
        if (role === "admin") {
          navigate("/admin");
        } else if (role == "subscriber") {
          secureLocalStorage.setItem("Id", userData.user_id);
          const status = response.data.subscriber != null ? true : false;
          secureLocalStorage.setItem("Subscription", status);
          if (secureLocalStorage.getItem("Subscription") == false) {
            navigate("/");
            return;
          }
          secureLocalStorage.setItem("Status", response.data.subscriber.status);
          secureLocalStorage.setItem(
            "SubInfo",
            JSON.stringify(response.data.subscriber)
          );
          navigate("/subscriber");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to send credientials",
          text: "Fail to log in to your account.",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
          style: {
            backgroundColor: "var(--color-black)",
          },
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Password and Email not match",
        text: "Fail to log in to your account.",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
        style: {
          backgroundColor: "var(--color-black)",
        },
      });
    }
  };

  return (
    <div className="loginWrapper">
      <Header disappearNavlink={true} disappearRegister={true} />
      <div className="login-container">
        <section className="username-input-parent">
          <div className="username-input">
            <h1 className="sign-in4">Sign In</h1>
            <div className="sign-in-with1">Sign in with Forex Miner</div>
          </div>
          <form className="sign-up-link">
            <div className="frame-parent6">
              <div className="username-or-email-address-parent3">
                <div className="username-or-email7">Email</div>
                <input
                  className="email-input6"
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
              <div className="password-parent">
                <div className="password4">Password</div>
                <input
                  className="email-input6"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                />
                {showPassword ? (
                  <VisibilityOffIcon
                    className="toggle-password-icon"
                    onClick={handleTogglePasswordVisibility}
                  />
                ) : (
                  <VisibilityIcon
                    className="toggle-password-icon"
                    onClick={handleTogglePasswordVisibility}
                  />
                )}
              </div>
              <div className="checkbox-container">
                <div className="checkbox">
                  <input
                    className="sign-in-with-forex-miner-link"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <div className="password5">Login as Admin</div>
                </div>
                <div className="password6">
                  <a href="/forget-password" className="forgot-password-link">
                    Forgot Password
                  </a>
                </div>
              </div>
            </div>
            <button className="sign-in-container" onClick={handleClickEvent}>
              <div className="sign-in5">Sign in</div>
            </button>
          </form>
        </section>
        <footer className="frame-footer">
          {/* <div className="username-or-email8">
            or sign in with other accounts?
          </div>
          <div className="socail-links2">
            <div className="wrapper-gmail2">
              <img
                className="gmail-icon2"
                loading="lazy"
                alt=""
                src="/gmail@2x.png"
              />
            </div>
          </div> */}
          <div className="dont-have-an-container1">
            <span>{`Don't have an account? `}</span>
            <span className="click-here-to1">
              <a href="/signup">Click here to sign up.</a>
            </span>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default SignIn;
